import styled from "styled-components";
import footerbg from "../../Images/footerbg.png";
export const FooterWrapper = styled.footer`
  background: url(${footerbg});
  background-size: cover;
  padding: 6rem 0;
  background-position: center;
  h1 {
    font-size: 3.2rem;
    color: #fbfbfb;
    margin-bottom: 4rem;
    @media screen and (max-width: 667px) {
      font-size: 2.7rem;
    }
    @media screen and (max-width: 398px) {
      font-size: 2.4rem;
    }
  }

  h4 {
    font-size: 1.8rem;
    color: #fbfbfb;
    font-weight: normal;
    margin-bottom: 2.5rem;
  }
`;

export const FooterGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(20rem, 1fr));
  align-items: start;
  grid-row-gap: 4rem;
`;

export const FooterSide = styled.div`
  width: 100%;
`;
export const LittleFooter = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 6rem;
  img {
    height: 2.5rem;
  }
`;
